import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const foodOperatorImporterSelectors = importerSelectors(
  'foodOperator.importer',
);

export default foodOperatorImporterSelectors;
